import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

import type {User} from '@gauged/gauged-js';
import {RootState} from 'store';

const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState: {
        value: null as User | null,
    },
    reducers: {
        setCurrentUser: (state, action: PayloadAction<User|null>) => {
            state.value = action.payload;
        }
    }
});

export const { setCurrentUser } = currentUserSlice.actions;
export const selectCurrentUser = (state: RootState) => state.currentUser.value;

export default currentUserSlice.reducer;
